import { VpActionChip, VpIcon } from '@vtmn-play/react'
import { useTranslation } from 'react-i18next'
import { useSearchParams } from 'react-router'
import { getActiveFiltersCount } from '@/components/ProductsHeader/utils'
import { useProductsContext } from '@/contexts/products/useProductsContext'

export function ProductsViewHeaderFilterControl() {
  const { t } = useTranslation()
  const [searchParams] = useSearchParams()
  const { filterGroups, isFiltersOpen, setIsFiltersOpen } = useProductsContext()
  const filtersCount = getActiveFiltersCount(filterGroups, searchParams)

  return (
    <VpActionChip
      size="small"
      className="products-view-header__filter-chip"
      onClick={() => setIsFiltersOpen(!isFiltersOpen)}
    >
      <VpIcon name="equalizer" />
      {isFiltersOpen ? t('products-page.filters.hide-filters') : t('products-page.filters.title')}
      {!!filtersCount && (
        <span className="products-view-header__filter-count">
          (
          {filtersCount}
          )
        </span>
      )}
    </VpActionChip>
  )
}
